module.exports = __webpack_public_path__ + "img/icon_plan.60befb57.svg";